import { createSlice, current } from '@reduxjs/toolkit'

const parameterList = createSlice({
    name: 'parameterList',
    initialState: {
        list: [],
        listObject: [],
        listProject: [],
        listLoaded: []
    },
    reducers: {
        //id_tab: 1-Активные; 0-Архивные;
        //id_tab = id_status
        load(state, action) {
            const id_tab = action.payload.id_tab;
            const list = action.payload.list;
            state.list = [...state.list.filter(a => a.id_tab !== id_tab), ...list.map((item) => { return { ...item, id_tab: id_tab, filter_project: false, filter_object: false, filter_type: false } })].sort((a, b) => a.ID - b.ID);
            state.listLoaded = [...state.listLoaded.filter(a => a.id_tab !== id_tab), { id_tab: id_tab }];
        },
        loadObject(state, action) {
            const id_tab = action.payload.id_tab;
            const list = action.payload.list;
            state.listObject = [...state.listObject.filter(a => a.id_tab !== id_tab), ...list.map((item) => { return { ...item, id_tab: id_tab } })];
        },
        loadProject(state, action) {
            const id_tab = action.payload.id_tab;
            const list = action.payload.list;
            state.listProject = [...state.listProject.filter(a => a.id_tab !== id_tab), ...list.map((item) => { return { ...item, id_tab: id_tab } })];
        },
        update(state, action) {
            const id_parameter = action.payload.id_parameter;
            const model = action.payload.model;

            state.list = [...state.list.filter(a => a.ID !== id_parameter), { ...model, id_tab: model.ID_Status, filter_project: false, filter_object: false, filter_type: false }].sort((a, b) => a.ID - b.ID);
        },
        updateObject(state, action) {
            const id_parameter = action.payload.id_parameter;
            const data = action.payload.data;
            const ID_Tab = state.list.filter(a => a.ID !== id_parameter)[0].ID_Status;
            state.listObject = [...state.listObject.filter(a => a.ID_Parameter !== id_parameter), ...data.map((item) => { return { ...item, id_tab: ID_Tab } })];
        },
        updateProject(state, action) {
            const id_parameter = action.payload.id_parameter;
            const data = action.payload.data;
            const ID_Tab = state.list.filter(a => a.ID !== id_parameter)[0].ID_Status;
            state.listProject = [...state.listProject.filter(a => a.ID_Parameter !== id_parameter), ...data.map((item) => { return { ...item, id_tab: ID_Tab } })];
        },
        remove(state, action) {
            const id_parameter = action.payload.id_parameter;
            state.list = [...state.list.filter(a => a.ID !== id_parameter)].sort((a, b) => a.ID - b.ID);
            state.listObject = [...state.listObject.filter(a => a.ID_Parameter !== id_parameter)];
            state.listProject = [...state.listProject.filter(a => a.ID_Parameter !== id_parameter)];
        },
        filterProject(state, action) {
            const id_tab = action.payload.id_tab;
            const id_project = action.payload.id_project;

            //Очишаем предыдущие значения
            state.list = state.list.map((item) => {
                if (item.id_tab === id_tab) {
                    return { ...item, filter_project: false }
                }
                else {
                    return { ...item }
                }
            })

            //Устанавливаем/снимаем фильтр
            if (id_project > 0) {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & state.listProject.filter(a => a.ID_Parameter === item.ID & a.ID_Project === id_project).length === 0) {
                        return { ...item, filter_project: true }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
            if (id_project === 0) {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & item.All_Project !== true) {
                        return { ...item, filter_project: true }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
        },
        filterObject(state, action) {
            const id_tab = action.payload.id_tab;
            const id_object = action.payload.id_object;

            //Очишаем предыдущие значения
            state.list = state.list.map((item) => {
                if (item.id_tab === id_tab) {
                    return { ...item, filter_object: false }
                }
                else {
                    return { ...item }
                }
            })

            //Устанавливаем/снимаем фильтр
            if (id_object > 0) {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & state.listObject.filter(a => a.ID_Parameter === item.ID & a.ID_Object === id_object).length === 0) {
                        return { ...item, filter_object: true }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
            if (id_object === 0) {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & item.All_Object !== true) {
                        return { ...item, filter_object: true }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
        },
        filterType(state, action) {
            const id_tab = action.payload.id_tab;
            const id_type = action.payload.id_type;

            //Очишаем предыдущие значения
            state.list = state.list.map((item) => {
                if (item.id_tab === id_tab) {
                    return { ...item, filter_type: false }
                }
                else {
                    return { ...item }
                }
            })

            //Устанавливаем/снимаем фильтр
            if (id_type !== -1) {
                state.list = state.list.map((item) => {
                    if (item.id_tab === id_tab & item.ID_Type !== id_type) {
                        return { ...item, filter_type: true }
                    }
                    else {
                        return { ...item }
                    }
                })
            }
        },
    }
})

export const { load, loadObject, loadProject, remove, update, filterProject, filterObject, filterType, updateObject, updateProject } = parameterList.actions
export default parameterList.reducer